import { render, staticRenderFns } from "./LoadedTasks.vue?vue&type=template&id=1b67907e&scoped=true&"
import script from "./LoadedTasks.vue?vue&type=script&lang=js&"
export * from "./LoadedTasks.vue?vue&type=script&lang=js&"
import style0 from "./LoadedTasks.vue?vue&type=style&index=0&id=1b67907e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b67907e",
  null
  
)

export default component.exports